module.exports = __webpack_public_path__ + "static/img/n-one.a849a2ec.png";